module.exports = __webpack_public_path__ + "h5/img/money.e4aa2185.png";